import { Objekt } from './objekt';
import { inject, Injector } from '@angular/core';
import { handleRequestError, menuItems, Scan, scan } from '@softline/application';
import { ScanObjektService } from './scan-objekt.service';
import { MessageBarService } from '@softline/ui-core';

export function scanObjekt(callback: (object: Objekt) => Promise<void>) {
  const scanObjectService = inject(ScanObjektService);
  const injector = inject(Injector);
  const messageBarService = inject(MessageBarService);
  scan(async (scan: Scan) => {
    try {
      const result = await scanObjectService.load(scan)
      if(!result) {
        messageBarService.warning(`Es konnte kein Object mit dem Barcode ${scan.data} gefunden werden.`);
        return;
      }
      await callback(result);
    }
    catch (e) {
      handleRequestError(e, injector, {show: true});
    }
  }, {labelTypes: ['code39']})
  return menuItems;
}
